<template>
	<div class="container-form-edit">
		<div class="container-empresas-vinculadas">
			<div class="header-emp-v">
				<h1>Empresas Vinculadas</h1>
			</div>
			<div>
				<b-table :data="vincEmpPag">
					<b-table-column
						v-slot="props"
						field="id"
						label="ID"
						width="40"
						numeric
						centered
						header-class="custom-header"
					>
						<h1 class="row-text">
							{{ props.row.id }}
						</h1>
					</b-table-column>

					<b-table-column
						v-slot="props"
						field="nomerazao"
						header-class="custom-header"
						label="Razão Social"
						centered
					>
						<h1 class="row-text">
							{{ props.row.nomerazao }}
						</h1>
					</b-table-column>

					<b-table-column
						v-slot="props"
						field="fantasia"
						header-class="custom-header"
						label="Fantasia"
						centered
					>
						<h1 class="row-text">
							{{ props.row.fantasia }}
						</h1>
					</b-table-column>
					<b-table-column
						v-slot="props"
						field="cpfcnpj"
						header-class="custom-header"
						label="CPF/CNPJ"
						centered
					>
						<h1 class="row-text">
							{{ props.row.cpfcnpj }}
						</h1>
					</b-table-column>
					<b-table-column
						v-slot="props"
						field="status"
						header-class="custom-header"
						label="Status"
						centered
					>
						<h1 class="row-text">
							{{ props.row.status }}
						</h1>
					</b-table-column>
				</b-table>
			</div>
		</div>
		<div class="container-empresas-vinculadas">
			<div class="header-emp-v">
				<h1>Pagamentos Vinculados</h1>
			</div>
			<div>
				<b-table :data="vincPagCond">
					<b-table-column
						v-slot="props"
						field="id"
						label="ID"
						width="40"
						numeric
						header-class="custom-header"
						centered
					>
						<h1 class="row-text">
							{{ props.row.id }}
						</h1>
					</b-table-column>

					<b-table-column
						v-slot="props"
						field="descricao"
						header-class="custom-header"
						label="Descrição"
						centered
					>
						<h1 class="row-text">
							{{ props.row.descricao }}
						</h1>
					</b-table-column>

					<b-table-column
						v-slot="props"
						field="associado_id"
						header-class="custom-header"
						label="Associado ID"
						centered
					>
						<h1 class="row-text">
							{{ props.row.associado_id }}
						</h1>
					</b-table-column>
					<b-table-column
						v-slot="props"
						field="integracao_id"
						header-class="custom-header"
						label="Integração ID"
						centered
					>
						<h1 class="row-text">
							{{ props.row.integracao_id }}
						</h1>
					</b-table-column>
					<b-table-column
						v-slot="props"
						field="status"
						header-class="custom-header"
						label="Status"
						centered
					>
						<h1 class="row-text">
							{{ props.row.status }}
						</h1>
					</b-table-column>
				</b-table>
			</div>
		</div>
	</div>
</template>

<script>
import * as ecAxios from '../../util/ecAxios';

export default {
	data() {
		return {
			vincPagCond: [],
			vincEmpPag: [],
			empPagCollumn: [
				{
					field: 'id',
					label: 'ID',
					width: '40',
					numeric: true,
				},
				{
					field: 'nomerazao',
					label: 'Razão Social',
				},
				{
					field: 'pessoa_id',
					label: 'Pessoa Id',
				},
				{
					field: 'rgie',
					label: 'RGIE',
					centered: true,
				},
				{
					field: 'status',
					label: 'Status',
				},
				{
					field: 'tipopessoa',
					label: 'Tipo Pessoa',
				},
			],
			pagamentoCollumn: [
				{
					field: 'id',
					label: 'ID',
					width: '40',
					numeric: true,
				},
				{
					field: 'descricao',
					label: 'Descrição',
				},
				{
					field: 'integracao_id',
					label: 'Integração Id',
				},
				{
					field: 'validdaysavg',
					label: 'validdaysavg',
					centered: true,
				},
				{
					field: 'status',
					label: 'Status',
				},
				{
					field: 'associado_id',
					label: 'Associado ID',
				},
			],
		};
	},
	created() {
		this.getDataDetails();
	},
	methods: {
		async getDataDetails() {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_COND_PAGAMENTO}`, {
					formpgto_id: this.$route.params.id,
				})
				.then((response) => {
					this.vincPagCond = response.data.condpgtos;
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_EMPRESA}`, {
					formpgto_id: this.$route.params.id,
				})
				.then((response) => {
					this.vincEmpPag = response.data.empresas;
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.header-emp-v {
	padding: 20px;
}
.header-emp-v h1 {
	color: #343a40;
	font-weight: bold;
	font-size: 14px;
}
.container-empresas-vinculadas {
	display: flex;
	width: 100%;
	margin-bottom: 20px;
	flex-direction: column;
	background-color: #ffffff;
}
.container-form-edit {
	display: flex;
	flex-direction: column;
	width: 100%;
}
.row-text {
	color: $row-color;
	font-weight: $row-weight;
	margin-top: 5px;
	margin-bottom: 2px;
	font-size: $row-size;
	text-align: center;
}
.custom-header {
	font-size: $header-size;
	font-weight: $header-weight;
	color: $header-color;
}
</style>

